import { Checkbox, FormControl, Select } from '@visualfabriq/vf-ui-kit';

import * as DataStagingStep from 'src/dto/PipelineStep/DataStagingStep';
import { useState } from 'react';

type ToBooleanMethodProps = {
  fields: DataStagingStep.ToBoolean;
  onUpdate: (event: { fields: { defaultValue: string | null; forceType: boolean } }) => void;
};

export function ToBooleanMethod(props: ToBooleanMethodProps) {
  const { fields, onUpdate } = props;

  const [defaultValue, setDefaultValue] = useState<'true' | 'false'>(String(fields.default) as 'true' | 'false');
  const [forceType, setForceType] = useState(fields.force_type);

  const BOOLEAN_OPTIONS = [
    { label: 'True', id: 'true' },
    { label: 'False', id: 'false' },
  ];

  const handleDefaultValueOnChange: React.ComponentProps<typeof Select>['onChange'] = (params) => {
    const value = params.value[0]?.id as 'true' | 'false';

    setDefaultValue(value as 'true' | 'false');

    onUpdate({
      fields: {
        forceType: fields.force_type,
        defaultValue: value,
      },
    });
  };

  const handleForceTypeOnChange: React.ComponentProps<typeof Checkbox>['onChange'] = (event) => {
    setForceType(event.target.checked);
    onUpdate({
      fields: {
        ...fields,
        forceType: event.target.checked,
        defaultValue: defaultValue,
      },
    });
  };

  return (
    <>
      <FormControl label="Default Value" disabled={false} required>
        <Select options={BOOLEAN_OPTIONS} value={[{ id: defaultValue }]} onChange={handleDefaultValueOnChange} />
      </FormControl>

      <Checkbox checked={forceType} onChange={handleForceTypeOnChange}></Checkbox>
    </>
  );
}
